<template>
  <div class="home">
    <h1>Course Info</h1>

    <p><b>Starting March 30</b>, all lectures, labs, and office hours will be held via Zoom.
        See <a href="https://elearning.mines.edu/courses/21464/pages/zoom-connection-info" target="_blank">Canvas</a>
        for Zoom meeting room information.
    </p>

    <table class="lined-table">
      <tr>
        <td><b>Lecture Section A</b></td>
        <td>MW 12:00-12:50 <br/><!--MZ 326--></td>
      </tr>
      <tr>
        <td><b>Lecture Section B</b></td>
        <td>MW 1:00-1:50 <br/><!--CT 102--></td>
      </tr>
      <tr>
        <td><b>Lecture Section C</b></td>
        <td>MW 2:00-2:50 <br/><!--MZ 335--></td>
      </tr>
      <tr>
        <td><b>Recitation (Lab) Section R01</b></td>
        <td>F 12:00-12:50 <br/><!--MZ 026--></td>
      </tr>
      <tr>
        <td><b>Recitation (Lab) Section R02</b></td>
        <td>F 1:00-1:50 <br/><!--MZ 026--></td>
      </tr>
      <tr>
        <td><b>Recitation (Lab) Section R03</b></td>
        <td>F 2:00-2:50 <br/><!--MZ 026--></td>
      </tr>
      <tr>
        <td><b>Recitation (Lab) Section R04</b></td>
        <td>F 4:00-4:50 <br/><!--MZ 026--></td>
      </tr>
    </table>
    <p/>
    <table class="unlined-table">
      <tr>
        <td><b>Textbook:</b></td>
        <td><a href="https://www.wiley.com/en-us/Big+C%2B%2B%3A+Late+Objects%2C+Enhanced+eText%2C+3rd+Edition-p-9781119402978" target="_blank"><i>Big C++: Late Objects</i></a>, Enhanced eText, 3<sup>rd</sup> Edition, by Cay Horstmann<br/>
  If you prefer, there is also a print edition, <i>Big C++ 3rd Edition EPUB Reg Card Abridged Print Companion Set</i></td>
      </tr>
      <tr>
        <td><b>Links:</b> </td>
        <td><a href="https://elearning.mines.edu/login/saml" target="_blank">Canvas</a></td>
      </tr>
      <tr>
        <td></td>
        <td><a href="https://piazza.com/mines/spring2020/csci262" target="_blank">Piazza</a></td>
      </tr>
    </table>
    <p/>
    <h2>Office Hours</h2>
    <!--
    <p><b>TBA</b></p>
  -->
    <!--
    <p>Office hours this semester will be held in BB 280K (inside Suite 280, the large open area outside Dr. Painter-Wakefield's office), except as noted below.</p>
-->
    <p><b>Starting March 30</b>, all office hours will be held via Zoom.
      See <a href="https://elearning.mines.edu/courses/21464/pages/zoom-connection-info" target="_blank">Canvas</a>
      for Zoom meeting room information.
    </p>
    <table class="lined-table">
        <tr>
            <td><b>Mondays</b></td>
            <td>
              10:30 - 11:30am (Kristin)
              <br/>
              Noon - 2pm (Hannah, Jake)
              <br/>
              3 - 4pm (Anthony, Ethan)
            </td>
        </tr>
        <tr>
            <td><b>Tuesdays</b></td>
            <td>
              9:45 - 10:45am (Mark)
              <br/>
              11am - 1pm (Alex, Hannah)
              <br/>
              2 - 4:30pm (Luke, CPW)
            </td>
        </tr>       
        <tr>
            <td><b>Wednesdays</b></td>
          <td>
            10:30 - 11:30am (Kristin)
            <br/>
            12:45 - 1:45 (Mark)
            <br/>
            2 - 4pm (CPW, Olivia, Beck)
          </td>
        </tr>       
        <tr>
            <td><b>Thursdays</b></td>
            <td>
              9 - 11am (Arthur)
              <br/>
              9:45 - 10:45am (Mark)
              <br/>
              3:30 - 4:30pm (Ethan)
            </td>
        </tr>  
        <tr>
            <td><b>Fridays</b></td>
            <td>3 - 4pm (Anthony, Ethan, Jake)</td>
        </tr>       
    </table>

    <p/>
    <h2>Instructor Info</h2>

    <table class="unlined-table">
      <tr>
        <td style="vertical-align: middle;">
          <img src="../assets/photos/kristin.jpg" width="120" alt="Kristin Farris" />
        </td>
        <td style="vertical-align: middle;">
          <table>
            <tr>
              <td colspan="2">
                <div><b>Sections A &amp; R01</b></div>
                <div>Kristin Farris <i>(she, her, hers)</i></div>
              </td>
            </tr>
            <tr>
              <td>email: </td>
              <td><a href="mailto:kfarris@mymail.mines.edu">kfarris@mymail.mines.edu</a></td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <p/>
    <table class="unlined-table">
      <tr>
        <td style="vertical-align: middle;">
          <a href="http://inside.mines.edu/~cpainter" target="_blank">
            <img src="../assets/photos/cpw.jpg" width="120" alt="Christopher Painter-Wakefield" />
          </a>
        </td>
        <td>
          <table>
            <tr>
              <td colspan="2">
                <div><b>Sections B &amp; R02, Course Coordinator</b></div>
                <div><a href="http://inside.mines.edu/~cpainter" target="_blank">Christopher Painter&#8209;Wakefield</a>
                <i> (he, him, his)</i></div>
              </td>
            </tr>
            <tr>
            </tr>
            <tr>
              <td>Office: </td>
              <td>BB 280 N</td>
            </tr>
            <tr>
              <td>Phone: </td>
              <td>303-273-3717</td>
            </tr>
            <tr>
              <td>email: </td>
              <td><a href="mailto:cpainter@mines.edu">cpainter@mines.edu</a></td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <p/>
    <table class="unlined-table">
      <tr>
        <td style="vertical-align: middle;">
          <img src="../assets/photos/mark.jpg" width="120" alt="Mark Baldwin" />
        </td>
        <td style="vertical-align: middle;">
          <table>
            <tr>
              <td colspan="2">
                <div><b>Sections C &amp; R03</b></div>
                <div>
                  Mark Baldwin
                </div>
              </td>
            </tr>
            <tr>
              <td>Office: </td>
              <td>BB 312</td>
            </tr>
            <tr>
              <td>Phone: </td>
              <td>303-384-2486</td>
            </tr>
            <tr>
              <td>email: </td>
              <td><a href="mailto:baldwin@mines.edu">baldwin@mines.edu</a></td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <p/>
    <table class="unlined-table">
      <tr>
        <td style="vertical-align: middle;">
          <img src="../assets/photos/arthur.jpg" width="120" alt="Arthur Mayer" />
        </td>
        <td style="vertical-align: middle;">
          <table>
            <tr>
              <td colspan="2">
                <div><b>Section R04</b></div>
                <div>Arthur Mayer <i>(he, him, his)</i></div>
              </td>
            </tr>
            <tr>
              <td>email: </td>
              <td><a href="mailto:arthurmayer@mymail.mines.edu">arthurmayer@mymail.mines.edu</a></td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <p/>

    <h2>TA Staff</h2>
    <div class="ta-list">
      <div class="ta-entry">
        <div class="ta-item"><img src="../assets/photos/anthony.jpg" alt="Anthony Arellano-Gandy" class="portrait"/></div>
        <div class="ta-item">Anthony Arellano&#8209;Gandy</div>
      </div>

      <div class="ta-entry">
        <div class="ta-item"><img src="../assets/photos/beck.jpg" alt="Beck Bolinger" class="portrait"/></div>
        <div class="ta-item">Beck Bolinger</div>
      </div>

      <div class="ta-entry">
        <div class="ta-item"><img src="../assets/photos/gabee.jpg" alt="Gabee Falconer-Stout" class="portrait"/></div>
        <div class="ta-item">Gabee Falconer&#8209;Stout</div>
      </div>

      <div class="ta-entry">
        <div class="ta-item"><img src="../assets/photos/luke.jpg" alt="Luke Henke" class="portrait"/></div>
        <div class="ta-item">Luke Henke</div>
      </div>

      <div class="ta-entry">
        <div class="ta-item"><img src="../assets/photos/jake.jpg" alt="Jake LaLuna" class="portrait"/></div>
        <div class="ta-item">Jake LaLuna</div>
      </div>

      <div class="ta-entry">
        <div class="ta-item"><img src="../assets/photos/nathan.jpg" alt="Nathan Lambert" class="portrait"/></div>
        <div class="ta-item">Nathan Lambert</div>
      </div>

      <div class="ta-entry">
        <div class="ta-item"><img src="../assets/photos/hannah.jpg" alt="Hannah Lee" class="portrait"/></div>
        <div class="ta-item">Hannah Lee</div>
      </div>

      <div class="ta-entry">
        <div class="ta-item"><img src="../assets/photos/olivia.jpg" alt="Olivia Lomax" class="portrait"/></div>
        <div class="ta-item">Olivia Lomax</div>
      </div>

      <div class="ta-entry">
        <div class="ta-item"><img src="../assets/photos/ethan.jpg" alt="Ethan Perry" class="portrait"/></div>
        <div class="ta-item">Ethan Perry</div>
      </div>

      <div class="ta-entry">
        <div class="ta-item"><img src="../assets/photos/jennifer.jpg" alt="Jennifer Phan" class="portrait"/></div>
        <div class="ta-item">Jennifer Phan</div>
      </div>

      <div class="ta-entry">
        <div class="ta-item"><img src="../assets/photos/alex.jpg" alt="Alex Pollock" class="portrait"/></div>
        <div class="ta-item">Alex Pollock</div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>
